import type { CSSProperties } from 'react';
import { NavLink, Outlet } from 'react-router-dom';

const wrap: CSSProperties = { padding: 'var(--loop-space-300)' };
const tabRow: CSSProperties = {
  display: 'flex',
  gap: 'var(--loop-space-100)',
  borderBottom: '1px solid var(--loop-neutral-300)',
  marginBottom: 'var(--loop-space-300)',
};

const tabStyle = ({ isActive }: { isActive: boolean }): CSSProperties => ({
  padding: 'var(--loop-space-150) var(--loop-space-200)',
  color: isActive ? 'var(--loop-brand-700)' : 'var(--loop-neutral-800)',
  borderBottom: isActive ? '2px solid var(--loop-brand-600)' : '2px solid transparent',
  marginBottom: '-1px',
  textDecoration: 'none',
  fontSize: '0.875rem',
  fontWeight: isActive ? 528 : 400,
});

export function ConfigLayout() {
  return (
    <div style={wrap}>
      <nav style={tabRow} aria-label="Configuration sections">
        <NavLink to="/config" end style={tabStyle}>Settings</NavLink>
        <NavLink to="/config/users" style={tabStyle}>Users</NavLink>
        <NavLink to="/config/audit" style={tabStyle}>Audit Log</NavLink>
      </nav>
      <Outlet />
    </div>
  );
}
